import React from 'react';
import ReactDOM from 'react-dom';

import Button from 'react-bootstrap/Button';
import ButtonToolbar from 'react-bootstrap/ButtonToolbar';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Jumbotron from 'react-bootstrap/Jumbotron';



export default class IQBox_random extends React.Component {


    constructor(props){
        super(props);
        this.state = {
            clicked: false,
            class0: "",
            class1: "",
            class2: "",

        }
      }


    
    componentDidMount() {

        
        this.setState({ 
            
            class0: this.randomClass(),
            class1: this.randomClass(),
            class2: this.randomClass(),

          
        })

    }



  render() {




    const handleOnMouseDown = (e) => {
         
        console.log("handleOnMouseDown")

        this.setState({clicked: true})
   
       };
 
  
    this.randomPosition = () => 
    {
        
        return Math.floor(Math.random()*9)

    }

    this.randomClass = () => 
    {
        var class0 = "IQImg b" + this.randomPosition()

        if(Math.random() > 0.8)
        {
            class0 += " b_invert"
        }

        return class0
    }

    var class0 = this.state.class0;
    var class1 = this.state.class1;
    var class2 = this.state.class2;
    
  
   
    var elements = [


        <img value={this.props.value} className={class0} src={this.props.images[0]}></img>,
        <img value={this.props.value} className={class1} src={this.props.images[1]}></img>,
        <img value={this.props.value} className={class2} src={this.props.images[2]}></img>,
        
        <div>{this.props.column}</div>

    ]

    if(this.state.clicked == true)
    {
        elements.pop()
    }


    elements.push(<div class="sequence_num">{4}</div>)


    return (


            <div className="IQBox choice" onMouseDown={handleOnMouseDown} onClick={this.props.handleClick} value={this.props.value}>

               {elements}
            
            </div>

    );
  }
}
